<template>
  <div class="one-one-container" v-if="de">
    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ messages.DATA_SOURCE.Text_vod__c }}
        </label>
        <div class="selection">
          {{ originalDataElement.name }}
        </div>
      </div>
    </div>

    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ $t("fields") }}
        </label>
        <div class="selected-fields">
          <div
            class="expression-values"
            v-for="field in selectedFields"
            :key="field.label"
          >
            <div class="label">{{ field.label }}</div>
            <div class="value">{{ field.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import utils from "@/utils";

  export default {
    name: "OneOneCalculation",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      currentApp() {
        return utils.findAppByAppId(this.apps, this.appId);
      },
      de() {
        return this.currentApp.dataElements[this.deId];
      },
      originalDataElement() {
        if (
          this.de.original &&
          this.currentApp.dataElements[this.de.original]
        ) {
          return this.currentApp.dataElements[this.de.original];
        }

        return { name: "" };
      },
      selectedFields() {
        if (!this.de || !this.de.fields || !this.originalDataElement.name) {
          return [];
        }

        return Object.keys(this.de.fields).map(key => {
          const obj = this.de.fields[key];
          return {
            label: key,
            value: utils.findExpressionLabel(obj)
          };
        });
      },
      sorts() {
        return this.de.sort;
      }
    }
  };
</script>
<style scoped>
  .selected-fields {
    display: inline-block;
    flex-basis: 80%;
  }

  .field-container {
    display: flex;
    flex-basis: 100%;
  }

  .selection {
    display: inline-block;
  }

  .query-label {
    font-size: 0.85rem;
    font-weight: bold;
    flex-basis: 15%;
  }
  .expression-values {
    display: flex;
  }
  .label {
    flex: 2;
  }
  .value {
    flex: 4;
  }
</style>
